module.exports = __webpack_public_path__ + "1336e2e0a413c8385222a20cea264dd4.png";